<template>
    <div class="advertiser-page">
      
        <layout>
            <template v-slot:search>
                <div class="search-wrapper" ref="search">
                    <div class="title">
                        <a-icon type="search"/>
                        数据筛选
                    </div>
                    <a-divider></a-divider>
                    <a-space>
                        <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                            <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                              {{ corporation.name }}
                            </a-select-option>
                          </a-select>
                          
                        <a-popover title="广告主ID">
                            <template slot="content">
                                <a-textarea
                                v-model="out_ids"
                                placeholder="请输入广告主ID"
                                :auto-size="{ minRows: 5, maxRows: 8 }"
                              />
                            </template>
                            <a-input allow-clear placeholder="广告主ID" v-model="queryParam.out_id" @change="changeOutId"/>
                        </a-popover>

                        <a-input allow-clear placeholder="名称" v-model="queryParam.name"/>
                        <a-input allow-clear placeholder="备注" v-model="queryParam.remark"/>

                        <a-select allow-clear placeholder="应用类型" v-model="queryParam.app_type" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in appTypes" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        
                        <a-select allow-clear placeholder="是否新户" v-model="queryParam.is_new" show-search option-filter-prop="children" v-if="type=='juliang'">
                            <a-select-option :value="item.id" v-for="item in [{id:1,name:'是'}, {id:2,name:'否'}]" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>

                        <a-select allow-clear placeholder="优化师" v-model="queryParam.worker_id" show-search option-filter-prop="children">
                            <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id" >
                                {{ worker.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="小组" v-model="queryParam.team_id" show-search option-filter-prop="children">
                            <a-select-option :value="team.id" v-for="team in teams" :key="team.id" >
                                {{ team.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="授权账号" v-model="queryParam.account_id" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in mediaAccounts" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="绑定的优化师时间" v-model="queryParam.worker_bind_before_days" show-search option-filter-prop="children" style="width: 160px">
                            <a-select-option :value="item.id" v-for="item in workerBindBeforeDays" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="无消耗" v-model="queryParam.no_cost" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in noCosts" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="授权状态" v-model="queryParam.status" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in authStatus" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select allow-clear placeholder="是否检测" v-model="queryParam.check_close_project" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in [{id:1,name:'是'}, {id:0,name:'否'}]" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-input allow-clear placeholder="共享钱包ID" v-model="queryParam.wallet_id"/>
                        <a-select allow-clear placeholder="临时筛选" v-model="queryParam.advertisr_type" show-search option-filter-prop="children">
                            <a-select-option :value="item.id" v-for="item in advertisrTypes" :key="item.id" >
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-button type="primary" @click="search" title="点击回车直接查询" style="border:1px solid gold">查询 <span style="color:gold;font-size:10px"> (支持回车) </span></a-button>
                        <a-button @click="resetSearch">重置</a-button>
                    </a-space>
                </div>
            </template>

            <template v-slot:content >
              

             <vxe-grid
                class="table-scrollbar"
                v-bind="tableGrid"
                @page-change="handlePageChange"
                @sort-change="handleSortChange"
                @checkbox-change="handleRowChange"
                @checkbox-all="handleRowChange"
                :edit-config="editConfig"
                @edit-actived="handleEditActived"
                @edit-closed="handleEditClosed"
              >

              
                    <template #toolbar_buttons>
                        <a-space class="table-operator">
                            <a-button type="primary" icon="plus" v-if="accessTo('sync' + privilegeType)" @click="showPullForm">
                            拉取
                            </a-button>
                            <!-- 【已停用】代理商拉取入口
                            <a-button type="primary" icon="plus" v-if="type === 'kuaishou' && accessTo('sync' + privilegeType)" @click="showAgentPullForm">
                            代理商拉取
                            </a-button>
                            -->
                            <a-dropdown :disabled="selectedRowKeys.length === 0" v-if="accessTo(actions)">
                                <a-menu slot="overlay">

                                    <a-menu-item-group title="操作">  
                                        <!-- <a-menu-item key="1" @click="updateAdvertiser(null, true, 'enabled', true)" v-if="accessTo('update' + privilegeType)">
                                            <a-icon type="check-square"/>批量启用
                                        </a-menu-item>
                                        <a-menu-item key="2" @click="updateAdvertiser(null, false, 'enabled', true)" v-if="accessTo('update' + privilegeType)">
                                            <a-icon type="close-square"/>批量禁用
                                        </a-menu-item> -->
                                        <a-menu-item key="3" @click="destroy()" v-if="accessTo('destroy' + privilegeType)">
                                            <a-icon type="delete"/>批量删除
                                        </a-menu-item>
                                        <a-menu-item key="4" @click="bindWork()" v-if="accessTo('bindWorker')">
                                            <a-icon type="plus"/>绑定优化师
                                        </a-menu-item>

                                        <a-menu-item key="21" @click="storeAvatar(true)" style="color:green" v-if="accessTo('bindWorker') && type === 'juliang' && accessTo('storeAvatar')">
                                            <a-icon type="contacts" />绑定优化师并上传头像
                                        </a-menu-item>
                                        <a-menu-item key="200" @click="updateBudget()" v-if="accessTo('updateBudget')">
                                            <a-icon type="plus"/>批量修改预算
                                        </a-menu-item>
                                        <a-menu-item key="201" @click="updateRemark()" v-if="accessTo('updateRemark')">
                                            <a-icon type="plus"/>批量修改备注
                                        </a-menu-item>
                                        <a-menu-item key="202" @click="unbindWork()" v-if="accessTo('unbindWorker')">
                                            <a-icon type="plus"/>解绑优化师
                                        </a-menu-item>
                                        <a-menu-item key="203" @click="updateCheckCloseProject()" v-if="accessTo('updateRemark')">
                                            <a-icon type="plus"/>批量修改检测状态
                                        </a-menu-item>
                                        <a-menu-item key="204" @click="updateLabel()" v-if="accessTo('updateLabel')">
                                            <a-icon type="plus"/>批量设置标签
                                        </a-menu-item>
                                    </a-menu-item-group>

                                    <a-menu-item-group title="创建">  

                                        <a-menu-item key="9" @click="createPt(9)" v-if="(type === 'juliang' || type === 'kuaishou') && accessTo('createPt')">
                                            <a-icon type="plus" />创建<b style="color:red">常读</b>推广链接
                                        </a-menu-item>
                                        <a-menu-item key="91" @click="createPt(4)" v-if="(type === 'juliang' || type === 'kuaishou') && accessTo('createPt') && (teamSettings.platform_types?.length ? teamSettings.platform_types.includes(4) : true)">
                                            <a-icon type="plus" />创建<b style="color:red">点众</b>推广链接
                                        </a-menu-item>
                                        <a-menu-item key="92" @click="createPt(15)" v-if="(type === 'juliang' || type === 'zhangyue') && accessTo('createPt') && (teamSettings.platform_types?.length ? teamSettings.platform_types.includes(15) : true)">
                                            <a-icon type="plus" />创建<b style="color:red">掌阅</b>推广链接
                                        </a-menu-item>

                                        <a-menu-item key="6" @click="createApp()" v-if="type === 'juliang' && accessTo('createApp')">
                                            <a-icon type="cloud"/>创建小程序资产
                                        </a-menu-item>
                                        <!-- <a-menu-item key="23" @click="createProduct()" v-if="type === 'juliang' && accessTo('createApp')">
                                            <a-icon type="cloud"/>创建商品
                                        </a-menu-item> -->

                                        <a-menu-item key="16" @click="createEventAsset()" v-if="type === 'juliang' && accessTo('createEventAsset')">
                                            <a-icon type="cloud"/>创建事件资产
                                          </a-menu-item>
                                        <a-menu-item key="18" @click="createAndroidEventAsset()" v-if="type === 'juliang' && accessTo('createAndroidEventAsset')">
                                            <a-icon type="cloud"/>创建<b style="color:red">Android应用</b>事件资产
                                        </a-menu-item>
                                        <a-menu-item key="7" @click="createAnchor()" v-if="type === 'juliang' && accessTo('createAnchor')">
                                            <a-icon type="pushpin"/>创建锚点
                                        </a-menu-item>
                                        <a-menu-item key="8" @click="storeAvatar()" v-if="type === 'juliang' && accessTo('storeAvatar')">
                                            <a-icon type="user"/>上传/更新头像
                                        </a-menu-item>
                                    
                                        <a-menu-item key="13" @click="createProject()" v-if="type === 'juliang' && accessTo('AdTaskController@store')">
                                          <a-icon type="plus" />创建项目广告
                                        </a-menu-item>
                                    </a-menu-item-group>

                                    <a-menu-item-group title="同步">  
                                        <a-menu-item key="5" @click="syncCost()" v-if="accessTo('syncCost')" >
                                            <a-icon type="sync" style="color:orange"/>同步成本
                                        </a-menu-item>
                                        <a-menu-item key="10" @click="pullWechatApp(1)" v-if="type === 'juliang' && accessTo('pullWechatApp')">
                                            <a-icon type="sync" style="color:orange"/>同步<span style="color:red">微信</span>小程序资产
                                        </a-menu-item>
                                        <a-menu-item key="15" @click="pullWechatApp(2)" v-if="type === 'juliang' && accessTo('pullWechatApp')">
                                          <a-icon type="sync" style="color:orange"/>同步<span style="color:red">字节</span>小程序资产
                                       </a-menu-item>
                                       <a-menu-item key="17" @click="pullEventAsset()" v-if="type === 'juliang' && accessTo('pullEventAsset')">
                                          <a-icon type="sync" style="color:orange"/>同步事件资产
                                       </a-menu-item>
                                       <a-menu-item key="11" @click="pullAnchor()" v-if="type === 'juliang' && accessTo('pullAnchor')">
                                            <a-icon type="sync" style="color:orange"/>同步锚点
                                        </a-menu-item>
                                        <a-menu-item key="12" @click="pullAvatar()" v-if="type === 'juliang' && accessTo('pullAnchor')">
                                            <a-icon type="sync" style="color:orange"/>同步头像
                                        </a-menu-item>
                                        <a-menu-item key="14" @click="syncLandingPage()" v-if="['kuaishou', 'juliang'].includes(type) && accessTo('syncLandingPage')">
                                           <a-icon type="sync" style="color:orange"/>同步落地页
                                        </a-menu-item>
                                        <a-menu-item key="20" @click="syncRemark()" v-if="['juliang'].includes(type) && accessTo('syncLandingPage')">
                                         <a-icon type="sync" style="color:orange"/>同步备注
                                        </a-menu-item>
                                        <a-menu-item key="22" @click="syncAdvertiserName()" v-if="['kuaishou'].includes(type)">
                                            <a-icon type="sync" style="color:orange"/>同步昵称
                                           </a-menu-item>
                                    </a-menu-item-group>
                                </a-menu>
                                <a-button> 批量操作
                                    <a-icon type="down"/>
                                </a-button>
                            </a-dropdown>

                            <a-button :disabled="selectedRowKeys.length === 0" @click="copyOutIds"> 复制账户ID </a-button>
                            <a-button v-if="type === 'juliang' && accessTo('createApp')" @click="createProduct(2)"> 创建付费商品 </a-button>
                            <a-button v-if="type === 'juliang'" @click="batchUpload()"> 批量设置邮箱 </a-button>
                            <a-button v-if="type === 'juliang'" @click="exportCsv()"> 导出广告主 </a-button>
                        </a-space>
                    </template>

                    <template #out_id="{ row }">
                        <span @click="copyToken(row.out_id)">{{ row.out_id }}</span>

                        <a href="javascript:;"  @click="clickJuliang(row.out_id)" v-if="row.media == 2" style="margin-left:5px;font-size:12px">
                            进入账户
                        </a>
                        <a :href="'https://ad.e.kuaishou.com/index?__accountId__='+row.out_id" target="_blank" v-if="row.media == 1" style="margin-left:5px;font-size:12px">
                            进入账户
                        </a>

                    </template>

                    
                    <template #name="{ row }">
                        <a-tag color="orange" v-if="row.app_type === 2">抖小</a-tag>
                        <a-tag color="cyan" v-if="row.app_type === 1">微小</a-tag>
                        <span>{{ row.name }}</span>
                    </template>

                    <template #apps="{ row }">
                        <div v-if="row.juliang_apps.length<1"> - </div>
                        <a-tooltip v-else>
                            <template slot="title">
                                <div v-for="item in row.juliang_apps" :key="item.id">
                                    {{ item.instance_id }}[{{ item.type == 2 ? '字节':'微信' }}]
                                </div>
                            </template>
                            {{ row.juliang_apps[0].instance_id }} [{{ row.juliang_apps[0].type == 2 ? '字节':'微信' }}]

                            <a-tag color="orange" v-if="row.juliang_apps.length>1">
                                多资产
                            </a-tag>
                        </a-tooltip>
                    </template>

                    <template #anchors="{ row }">
                        <div v-if="row.anchors.length<1"> - </div>
                        <a-tooltip v-else>
                            <template slot="title">
                                <div v-for="item in row.anchors" :key="item.id">
                                    {{ item.anchor_id }}
                                </div>
                            </template>
                            {{ row.anchors[0].anchor_id }}    
                            
                            <a-tag color="pink" v-if="row.anchors.length>1">
                                多锚点
                            </a-tag>
                        </a-tooltip>
                    </template>

                    <template #pts="{ row }">
                        <div v-if="row.pts.length<1"> - </div>
                        <a-tooltip v-else>
                            <template slot="title">
                                <div v-for="item in row.pts" :key="item.id">
                                    {{ item.out_id }}
                                </div>
                            </template>
                            {{ row.pts[0].out_id }}    
                            
                            <a-tag color="blue" v-if="row.pts.length>1">
                                多链接
                            </a-tag>
                        </a-tooltip>
                    </template>


                    <template #avatar="{ row }">
                        <template v-if="!row.has_avatar">
                            <a-tooltip v-if="type === 'juliang' && accessTo('storeAvatar')">
                                <template slot="title">
                                    点击同步头像
                                </template>
                                <a-tag color="red" @click="pullAvatar(row)">
                                    无
                                </a-tag>
                            </a-tooltip>

                            <a-tag v-else color="red">
                                无
                            </a-tag>
                        </template>

                        <a-tag v-else-if="row.avatar_status != 'AUDIT_PASS'" color="red" @click="pullAvatar(row)">
                            {{getAvatarStatusName(row.avatar_status)}}
                        </a-tag>
                      
                      
                        <a-tag v-else color="cyan">
                            有
                        </a-tag>
                    </template>


                    <template #pages="{ row }">
                        <div v-if="row.landing_pages.length<1"> - </div>
                        <a-tooltip v-else>
                            <template slot="title">
                                <div v-for="item in row.landing_pages" :key="item.id">
                                    {{ item.out_id }}
                                </div>
                            </template>
                            {{ row.landing_pages[0].out_id }}    
                            
                            <a-tag color="green" v-if="row.landing_pages.length>1">
                                多页面
                            </a-tag>
                            <a-button type="primary" v-if="accessTo('handsel') && type === 'juliang' " size="small" @click="clickHandsel(row)" :disabled="canHandsel(row)?false:true">
                                转赠
                            </a-button>
                        </a-tooltip>
                     </template>

                    <template #remark="{ row }">

                        <byted-link @click="syncRemark(row)" v-if="['juliang'].includes(type) && accessTo('syncLandingPage')">
                            同步
                        </byted-link>

                        <span>
                            {{ row.remark  }}
                        </span>
                       

                        
                     </template>

                    <template #enabled="{ row }">
                        <a-switch 
                        v-model="row.enabled"
                        @change="updateAdvertiser(row.id, row.enabled, 'enabled', false)"
                        :disabled="!accessTo('update' + privilegeType)"
                        />
                    </template>

                    <template #check_close_project="{ row }">
                        <a-switch 
                        v-model="row.check_close_project"
                        @change="updateAdvertiser(row.id, row.check_close_project, 'check_close_project', false)"
                        :disabled="!accessTo('update' + privilegeType)"
                        />
                    </template>

                    <template #status="{ row }">
                        <a-tag v-if="row.status === 1" color="blue">正常</a-tag>
                        <a-tag v-if="row.status === 2" color="red">授权过期</a-tag>
                        <a-tag v-if="row.status === 3" color="orange">未授权</a-tag>
                    </template>
            

                    <template #sync_cost="{ row }">
                        <a-switch v-model="row.sync_cost"
                                @change="updateAdvertiser(row.id, row.sync_cost, 'sync_cost', false)"
                                :disabled="!accessTo('update' + privilegeType) || row.account_id ==10 "/>
                    </template>


                    <template #action="{ row }"  v-if="accessTo(['destroy' + privilegeType, 'costs', 'wechatApplets', 'anchors', 'bindWorker']) || accessToJuliangProject('index') || ['kuaishou'].includes(type)">
                        <span v-if="accessTo('costs')">
                            <a href="javascript:;" @click="showPage(row)" v-if="accessTo('costs')">成本</a>
                            <a-divider type="vertical"/>
                        </span>
                    
                        <span v-if="accessTo('PromotionController@report') && ['juliang'].includes(type)">
                            <a href="javascript:;"  @click="showPromotionReport(row.media, row.out_id, '['+row.name+'] - '+ row.out_id)">广告</a>
                            <a-divider type="vertical"/>
                        </span>

                        <span v-if="accessTo('MediaCampaignController@index') && ['kuaishou'].includes(type)">
                            <a href="javascript:;" @click="showCampaignPage(row)">广告计划</a>
                            <a-divider type="vertical"/>
                        </span>

                        <!-- <span v-if="type === 'juliang' && accessTo('wechatApplets')">
                            <a href="javascript:;" @click="showWechatAppPage(row)" v-if="type === 'juliang' && accessTo('wechatApplets')">资产</a>
                            <a-divider type="vertical"/>
                        </span>
                     -->

                        <!-- <span v-if="type === 'juliang' && accessTo('anchors')">
                            <a href="javascript:;" @click="showAnchorPage(row)" v-if="type === 'juliang' && accessTo('anchors')">锚点</a>
                            <a-divider type="vertical"/>
                        </span> -->

                        <!-- <span v-if="accessToJuliangProject('index')">
                            <a href="javascript:;" @click="showProject(row)" >项目</a>
                            <a-divider type="vertical"/>
                        </span> -->
                    

                        <span v-if="accessTo('costs') && privilegeType === 'Vivo'">
                            <a href="javascript:;" @click="copyToken(row.access_token)" v-if="accessTo('costs') && privilegeType === 'Vivo'">令牌</a>
                            <a-divider type="vertical"/>
                        </span>
                    
                        <span v-if="accessTo('bindWorker')">
                            <a href="javascript:;" @click="bindWork(row)" v-if="accessTo('bindWorker')">优化师</a>
                            <a-divider type="vertical"/>
                        </span>
                    
                        <!-- <span  v-if="type === 'juliang' && accessTo('createApp')">
                            <a href="javascript:;" @click="createApp(row)" v-if="type === 'juliang' && accessTo('createApp')">创建资产</a>
                            <a-divider type="vertical"/>
                        </span> -->
                        
                        <!-- <span v-if="accessTo('destroy' + privilegeType)">
                            <a-popconfirm title="确认要删除吗?" @confirm="destroy(row)" v-if="accessTo('destroy' + privilegeType)">
                            <a href="javascript:;">删除</a>
                            </a-popconfirm>
                            <a-divider type="vertical"/>
                        </span> -->

                        <template v-if="accessTo(['wechatApplets', 'anchors']) || accessToJuliangProject('index')">
                            <a-dropdown >
                                <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                其他 <a-icon type="down" />
                                </a>
                                <a-menu slot="overlay">
                                <a-menu-item key="1" @click="showWechatAppPage(row)" v-if="type === 'juliang' && accessTo('wechatApplets')">资产</a-menu-item>
                                <a-menu-item key="2" @click="showAnchorPage(row)" v-if="type === 'juliang' && accessTo('anchors')">锚点</a-menu-item>
                                <a-menu-item key="3" @click="showProject(row)" v-if="accessToJuliangProject('index')">项目</a-menu-item>
                                <a-menu-item key="4" v-if="accessTo('destroy' + privilegeType)">
                                    <a-popconfirm title="确认要删除吗?" @confirm="destroy(row)">
                                        <a>删除</a>
                                    </a-popconfirm>
                                </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                         </template>
                    
                    </template>

                    <template #events="{ row }">
                        <div v-if="row.juliang_event_assets.length<1"> - </div>
                        <a-tooltip v-else>
                            <template slot="title">
                                <div v-for="item in row.juliang_event_assets" :key="item.id">
                                    {{ item.asset_id }}[{{ item.asset_name }}]
                                    <a-tag color="blue" v-if="item.asset_type === 'APP'">APP</a-tag>
                                </div>
                            </template>
                            {{ row.juliang_event_assets[0].asset_id }}[{{ row.juliang_event_assets[0].asset_name }}]

                            <a-tag color="orange" v-if="row.juliang_event_assets.length>1">
                                多事件
                            </a-tag>
                            <a href="javascript:;" v-if="getFirstAppEventAsset(row)" @click.stop="addAppEventAssetEvents(getFirstAppEventAsset(row))">
                                添加事件
                            </a>
                        </a-tooltip>
                    </template>

                    <template #puhu="{ row }">
                        <!-- <span v-if="accessToAdvertiser('advertiserTask') && [4,9,15].includes(row.p_type) && [1,2].includes(row.platform_app_type) && row.media === 2 && row.avatar_status == 'AUDIT_PASS'" :flex="1"> -->
                        <span v-if="accessToAdvertiser('advertiserTask') && (([4,9,15].includes(row.p_type) && [1,2].includes(row.platform_app_type)) || [3].includes(row.platform_app_type)) && row.media === 2 && row.avatar_status == 'AUDIT_PASS'" :flex="1">
                            <byted-button :type="row.advertisre_task_status == 1 ? (row.advertisre_task_error_count > 0 ? 'danger' : 'success') : (row.advertisre_task_status == 0 ? 'warning' : 'info' )" size="xs" @click="createAdvertiserTask(row)">
                                开始铺户
                            </byted-button>
                        </span>
                        <span v-else>-</span>
                    </template>

                    <template #email="{ row }">
                        <span v-if="row.email">
                        {{ row.email }}
                        </span>
                        <span v-else> - </span>
                        <a href="#" @click="showFormPage(row, 'email')" v-if="accessTo('update' + privilegeType)">
                            {{ type === 'kuaishou' ? (row.email ? '修改邮箱' : '绑定邮箱') : '修改' }}
                        </a>
                    </template>

                    <template #budget="{ row }">
                        <span v-if="row.budget">
                        {{ row.budget }}
                        </span>
                        <span v-else> - </span>
                        <!-- <a href="#" @click="updateBudget(row)"> 修改 </a>  -->
                    </template>
                    
                    <template #wallet="{ row }">
                        <span v-if="row.wallet && row.wallet.wallet_name">
                        <!-- <a href="javascript:;" @click="copy(row.wallet.wallet_id)" >{{ row.wallet.wallet_name }}<br>【{{ row.wallet.wallet_id || '-' }}】</a> -->
                        <a href="javascript:;" @click="copy(row.wallet.wallet_name)" >{{ row.wallet.wallet_name }}</a>
                        </span>
                        <span v-else> - </span>
                    </template>
                    <template #walletId="{ row }">
                        <span v-if="row.wallet && row.wallet.wallet_id">
                        <a href="javascript:;" @click="copy(row.wallet.wallet_id)" >{{ row.wallet.wallet_id }}</a>
                        </span>
                        <span v-else> - </span>
                    </template>
              </vxe-grid>

             
                
            </template>
        </layout>
        <pull-form
          v-if="showForm"
          :showForm.sync="showForm"
          :type="type"
          :oauthType="pullOauthType"
          @success="refresh"
        />
        <cost-form
          v-if="showCostForm"
          :showCostForm.sync="showCostForm"
          :model="model"
          @success="refresh"
        />
        <bind-form
          v-if="showBindWorkForm"
          :showBindWorkForm.sync="showBindWorkForm"
          :model="model"
          @success="refresh"
        />
        <unbind-form
          v-if="showunBindWorkForm"
          :showunBindWorkForm.sync="showunBindWorkForm"
          :model="model"
          @success="refresh"
        />
        <sync-cost-form
          v-if="showSyncCostForm"
          :showForm.sync="showSyncCostForm"
          :model="model"
          @success="refresh"
        />
        <create-app-form
          v-if="showAppForm"
          :showAppForm.sync="showAppForm"
          :model="model"
          :version_type="version_type"
          @success="refresh"
        />
        <show-wechatapps-form
          v-if="showWechatAppForm"
          :showWechatAppForm.sync="showWechatAppForm"
          :model="model"
          @success="refresh"
        />
        <show-anchors-form
          v-if="showAnchorForm"
          :showAnchorForm.sync="showAnchorForm"
          :model="model"
          @success="refresh"
        />
        <create-anchor-form
          v-if="showCreateForm"
          :showCreateForm.sync="showCreateForm"
          :anchorModel="anchorModel"
          @success="refresh"
        />
        <create-avatar-form
          v-if="showAvatarForm"
          :showAvatarForm.sync="showAvatarForm"
          :model="model"
          @success="refresh"
        />
        <create-pt-form
          v-if="showCreatePtForm"
          :showCreatePtForm.sync="showCreatePtForm"
          :model="model"
          :teamSettings="teamSettings"
          @success="refresh"
          @next="createApp(2)"
          @next2="createApp2"
        />
        <create-pt-zy-form
          v-if="showCreatePtZyForm"
          :showCreatePtZyForm.sync="showCreatePtZyForm"
          :model="model"
          @success="refresh"
          @next="createApp(2)"
          @next2="createApp2"
        />
        <show-projects-page
          v-if="showProjectPage"
          :showProjectPage.sync="showProjectPage"
          :model="model"
          @success="refresh"
        />
        <create-project-form
          v-if="showProjectForm"
          :showCreateForm.sync="showProjectForm"
          :params="model"
          :media="type"
          @success="refresh"
        />
        <create-handsel-form
          v-if="showHandselForm"
          :showHandselForm.sync="showHandselForm"
          :model="model"
          @success="refresh"
        />
        <create-event-asset-form
            v-if="showEventAssetForm"
            :showEventAssetForm.sync="showEventAssetForm"
            :eventAssetModel="eventAssetModel"
            @success="refresh"
        />
        <create-android-event-asset-form
            v-if="showAndroidEventAssetForm"
            :showAndroidEventAssetForm.sync="showAndroidEventAssetForm"
            :androidEventAssetModel="androidEventAssetModel"
            @success="refresh"
        />

        <a-modal
          title="添加Android应用事件"
          :visible="showAddAppEventForm"
          :confirm-loading="addAppEventLoading"
          @ok="submitAddAppEventAssetEvents"
          @cancel="showAddAppEventForm = false"
        >
          <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
            <a-form-model-item label="资产ID">
              <a-input v-model="addAppEventModel.asset_id" disabled />
            </a-form-model-item>
            <a-form-model-item label="应用">
              <a-input v-model="addAppEventModel.app_name" disabled />
            </a-form-model-item>
            <a-form-model-item label="事件">
              <a-checkbox-group v-model="addAppEventModel.event_ids" :options="addAppEventOptions" />
            </a-form-model-item>
          </a-form-model>
        </a-modal>

        <a-modal
          :title="`广告计划 - ${campaignModel.name || ''}【${campaignModel.out_id || ''}】`"
          :visible="showCampaignForm"
          :footer="null"
          width="1200px"
          destroyOnClose
          @cancel="showCampaignForm = false"
        >
          <div class="campaign-search">
            <a-space>
              <a-input allow-clear placeholder="广告计划ID" v-model="campaignQueryParam.campaign_id" />
              <a-input allow-clear placeholder="广告计划名称" v-model="campaignQueryParam.campaign_name" />
              <a-select mode="multiple" allow-clear placeholder="计划状态" v-model="campaignQueryParam.put_status" style="width: 280px">
                <a-select-option :value="1">投放中</a-select-option>
                <a-select-option :value="2">已暂停</a-select-option>
                <a-select-option :value="3">已删除</a-select-option>
                <a-select-option :value="4">执行中</a-select-option>
              </a-select>
              <a-button type="primary" icon="search" @click="searchCampaigns">查询</a-button>
              <a-button @click="resetCampaignSearch">重置</a-button>
            </a-space>
          </div>

          <div class="campaign-toolbar">
            <a-space>
              <a-button type="primary" icon="cloud-download" :loading="campaignPullLoading" @click="pullCampaigns">
                拉取广告计划
              </a-button>
              <a-button icon="reload" :loading="campaignTableGrid.loading" @click="fetchAdvertiserCampaigns">
                刷新
              </a-button>
              <a-button type="danger" icon="delete" :loading="campaignDeleteLoading" :disabled="campaignSelectedRows.length < 1" @click="deleteSelectedCampaigns">
                批量删除
              </a-button>
              <a-button type="danger" ghost icon="delete" :loading="campaignDeleteLoading" @click="deleteAllCampaigns">
                全部删除
              </a-button>
            </a-space>
          </div>

          <vxe-grid
            class="table-scrollbar"
            v-bind="campaignTableGrid"
            max-height="560"
            @page-change="handleCampaignPageChange"
            @checkbox-change="handleCampaignRowChange"
            @checkbox-all="handleCampaignRowChange"
          >
            <template #campaign_put_status="{ row }">
              <a-tag :color="campaignPutStatusColor[row.put_status] || 'default'">
                {{ campaignPutStatusMap[row.put_status] || '-' }}
              </a-tag>
            </template>
            <template #campaign_today_roi="{ row }">
              <span :style="{ color: isCampaignRoiDanger(row) ? 'red' : undefined }">
                {{ row.today_roi }}
              </span>
            </template>
            <template #campaign_actions="{ row }">
              <a href="javascript:;" v-if="row.put_status !== 3" @click="deleteCampaign(row)">删除</a>
              <span v-else>-</span>
            </template>
          </vxe-grid>
        </a-modal>

      <show-promotion-reports-page
            v-if="showPromotionReportPage"
            :showPromotionReportPage.sync="showPromotionReportPage"
            :model="model"
       />

       <create-product-form
        v-if="showCreateProductForm"
        :showCreateProductForm.sync="showCreateProductForm"
        :model="productModel"
        @success="refresh"
        />

        <advertiser-task-form
            v-if="showCreatePage"
            :showCreateForm.sync="showCreatePage"
            :params="model"
            media="juliang"
            @success="refresh"
        />

        <jump-juliang-page
            v-if="showJumpJuliangPage"
            :showJumpJuliangPage.sync="showJumpJuliangPage"
            :model="jumpJuliangModel"
        />

        <create-email-form
          v-if="showCreateEmailForm"
          :showCreateEmailForm.sync="showCreateEmailForm"
          :model="emailModel"
          @success="refresh"
        />

        <create-budget-form
          v-if="showCreateBudgetForm"
          :showCreateBudgetForm.sync="showCreateBudgetForm"
          :model="budgetModel"
          @success="refresh"
        />

        <remark-form
          v-if="showRemarkForm"
          :showRemarkForm.sync="showRemarkForm"
          :model="remarkModel"
          @success="refresh"
        />
        
        <label-form
          v-if="showLabelForm"
          :showLabelForm.sync="showLabelForm"
          :model="labelModel"
          @success="refresh"
        />

        <check-close-project-form
          v-if="showCheckCloseProjectForm"
          :showCheckCloseProjectForm.sync="showCheckCloseProjectForm"
          :model="checkCloseProjectModel"
          @success="refresh"
        />

        <upload-form
        v-if="showUploadForm"
        :showUploadForm.sync="showUploadForm"
        :model="uploadModel"
        @success="refresh"
        />

    </div>
</template>

<style lang="less" scoped>
@import 'Advertiser';
</style>

<script>
import Advertiser from './Advertiser'

export default Advertiser
</script>
